import { useTranslate } from "@tolgee/react";
import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";

const ErrorPage = React.lazy(() => import("./ErrorPage"));

function ErrorPageWrapper(props) {
  const { t } = useTranslate();
  usePageInit(
    t({
      key: "pages.errorPage.pageTitle",
      defaultValue: "Smart Portal - Error",
    }),
  );
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({
            key: "pages.errorPage.loading",
            defaultValue: "Loading...",
          })}
        />
      }
    >
      <ErrorPage {...props} />
    </Suspense>
  );
}

export default ErrorPageWrapper;
